import { version } from "../../package.json";
window.APP_VERSION = version;

export const theme = process.env.VUE_APP_THEME || "default";

/**
 * @description URL base de la API. En modo embebido dentro del WebView de la
 *              app mobile (flag `inAppWebView=true` en localStorage), reemplaza
 *              `localhost`/`127.0.0.1` por `10.0.2.2` — desde el emulador
 *              Android, `localhost` es el propio emulador, no el host. La IP
 *              `10.0.2.2` es el alias estándar de AVD para alcanzar el host.
 *              En browser web normal, queda la URL original.
 */
function resolveApiUrl() {
  const raw = process.env.VUE_APP_API_URL || "http://localhost:3000";
  if (
    typeof window !== "undefined" &&
    window.localStorage &&
    localStorage.getItem("inAppWebView") === "true"
  ) {
    return raw
      .replace("localhost", "10.0.2.2")
      .replace("127.0.0.1", "10.0.2.2");
  }
  return raw;
}

export const apiUrl = resolveApiUrl();

export const landingUrl =
  process.env.VUE_APP_LANDING_URL || "http://localhost:5173";

export const shopUrl = "https://gpsfarma.com/ofertas.html";

export const s3Url =
  process.env.VUE_APP_S3_URL || "https://gizhealth-local.s3.amazonaws.com";

/**
 * @description Construye la URL de un archivo almacenado en S3 (o mock local).
 * En producción usa s3Url. En desarrollo local (s3Url default), usa el endpoint
 * /api/local-files del backend que sirve desde storage/s3-local/.
 * @param {string} key - S3 key del archivo (ej: "organizations/x/users/y/avatar.png")
 * @returns {string} URL pública del archivo
 */
export function getFileUrl(key) {
  if (!key) return null;
  const isLocalDev = s3Url === "https://gizhealth-local.s3.amazonaws.com";
  if (isLocalDev) {
    return `${apiUrl}/api/local-files/${encodeURIComponent(key)}`;
  }
  return `${s3Url}/${key}`;
}

export const s3PublicUrl =
  process.env.VUE_APP_S3_PUBLIC_URL ||
  "https://gizhealth-local.s3.amazonaws.com";

/**
 * @description Construye la URL de un asset PÚBLICO (avatar, portada de
 * médico) del bucket público de S3. A diferencia de getFileUrl —que apunta
 * al bucket privado de archivos médicos— este bucket tiene lectura pública,
 * así las imágenes de perfil cargan sin URL firmada.
 * @param {string} key - S3 key del asset
 * @returns {string} URL pública del asset
 */
export function getPublicFileUrl(key) {
  if (!key) return null;
  const isLocalDev = s3PublicUrl === "https://gizhealth-local.s3.amazonaws.com";
  if (isLocalDev) {
    return `${apiUrl}/api/local-files/${encodeURIComponent(key)}`;
  }
  return `${s3PublicUrl}/${key}`;
}

export const audience = process.env.VUE_APP_AUDIENCE || "dashboard";

export const marketingWebsiteUrl =
  process.env.VUE_APP_MARKETING_WEBSITE_URL ||
  "https://gizhealth.com/patient.html";

export const iOSAppStoreUrl =
  process.env.VUE_APP_IOS_APP_STORE_URL || "javascript:;";

export const androidAppStoreUrl =
  process.env.VUE_APP_ANDROID_APP_STORE_URL || "javascript:;";

export const loginRedirectURL =
  process.env.VUE_APP_SCORES_REDIRECT_URL ||
  "https://dashboard.gizhealth.com/login";

export const supportEmail =
  process.env.VUE_APP_SUPPORT_EMAIL || "soporte@quantuxsalud.com";

export const mobileAppName =
  process.env.VUE_APP_MOBILE_APP_NAME || "Consultorio Quantux";

export const organizationId = process.env.VUE_APP_ORGANIZATION_ID || null;

export const enableChat =
  process.env.VUE_APP_ENABLE_CHAT === "true" ? true : false;

export const enableScores =
  process.env.VUE_APP_ENABLE_SCORES === "true" ? true : false;

export const enableEpisodeCreation =
  process.env.VUE_APP_ENABLE_EPISODE_CREATION === "false" ? false : true;

export const isIndicationsEnabled = true;
export const isAppointmentsEnabled = true;
export const isVideoRoomEnabled = true;

export const isPatientEvolutionEnabled =
  process.env.VUE_APP_PATIENT_EVOLUTION_ENABLED === "false" ? false : true;

// This enables Seguimientos
export const isMonitoringEnabled =
  process.env.VUE_APP_MONITORING_ENABLED === "false" ? false : true;

// This enables Protocolos
export const isProtocolsEnabled =
  process.env.VUE_APP_PROTOCOLS_ENABLED === "false" ? false : true;

// This enables Tasks
export const isTasksEnabled =
  process.env.VUE_APP_TASKS_ENABLED === "false" ? false : true;

// This enables programs
export const isProgramsEnabled =
  process.env.VUE_APP_PROGRAMS_ENABLED === "false" ? false : true;

const videoRoomEngines = ["twilio", "jitsi"];
export const videoRoomEngine = videoRoomEngines.includes(
  process.env.VUE_APP_VIDEO_ROOM_ENGINE
)
  ? process.env.VUE_APP_VIDEO_ROOM_ENGINE
  : "twilio";

export const isFormPrintingEnabled =
  process.env.VUE_APP_ENABLE_EVENTS_PRINT === "true" ? true : false;

export const isMassiveEnabled =
  process.env.VUE_APP_ENABLE_MASSIVE_ACTIONS === "true" ? true : false;

export const isAppointmentBookingEnabled =
  process.env.VUE_APP_ENABLE_APPOINTMENT_BOOKING === "false" ? false : true;

export const isAgendaVirtualEnabled =
  process.env.VUE_APP_AGENDA_VIRTUAL_ENABLED === "false" ? false : true;
export const isAgendaPricingEnabled =
  process.env.VUE_APP_AGENDA_PRICING_ENABLED === "false" ? false : true;

export const isConsultationOptionsCNCEnabled =
  process.env.VUE_APP_CONSULTATION_OPTIONS_CNC_ENABLED === "true";

export const isHCFormsEnabled =
  process.env.VUE_APP_HC_FORMS_ENABLED === "false" ? false : true;

export default {
  theme,
  apiUrl,
  landingUrl,
  shopUrl,
  s3Url,
  audience,
  marketingWebsiteUrl,
  iOSAppStoreUrl,
  androidAppStoreUrl,
  supportEmail,
  mobileAppName,
  organizationId,
  loginRedirectURL,
};
